import React, { useContext } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { AbilityContext } from 'utils/permissions';


export default ({
  component: C, perms, props: cProps, ...rest
}) => {
  const ability = useContext(AbilityContext);
  return (<Route
    {...rest}
    render={(props) => {
        if (ability.can(...perms)) {
          return <C {...props} {...cProps} />;
        }
        return <Redirect to="/404" />;
      }}
  />);
};
